export default [
  {
    position: "absolute",
    top: 3,
    left: 12,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "newstarterP3.ttTextOne",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_NewStarters_Navigation_Home",
    index: 0,
  },
  {
    position: "absolute",
    top: 3,
    left: 27.7,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "newstarterP3.ttTextTwo",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_NewStarters_Navigation_TeamMembers",
    index: 1,
  },
  {
    position: "absolute",
    top: 3,
    left: 33.9,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "newstarterP3.ttTextThree",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_NewStarters_Navigation_Dashboards",
    index: 2,
  },
  {
    position: "absolute",
    top: 3,
    left: 38.9,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "newstarterP3.ttTextFour",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_NewStarters_Navigation_Reports",
    index: 3,
  },
];
